export const LOGIN = "login";
export const LOGIN_POLO = "login_polo";
export const CHANGE_PASSWORD = "changePassword";
export const LOGOUT = "logout";
export const GET_ITEM = "getItem";
export const GET_ITEM_POST = "getItemPost";
export const GET_LIST = "getList";
export const GET_LIST_POST = "getListPost";
export const CREATE_OBJECT = "createObject";
export const DELETE_OBJECT = "deleteObject";
export const ATUALIZA_OBJECT = "atualizaObject";
export const LOGIN_STUDENT = "loginStudent";
export const LOGIN_STUDENT_VEST = "loginStudentVest";
export const LOGOUT_STUDENT = "logoutStudent";